const question = {
    important: { values: ['P'], rejectedProfiles: ['D'] },
    moderate: { values: ['E'] },
    none: { values: ['E', 'D'] },
};

export default question;
